// extracted by mini-css-extract-plugin
var _1 = "fieldset__yghpF";
export { _1 as "fieldset" }
